import React from 'react';
import { motion } from 'framer-motion';
import { ScanFace, Sparkles, Image as ImageIcon, ShieldAlert } from 'lucide-react';
import { useLanguage } from '../../i18n/LanguageContext';
interface IntroStepProps {
  onStart: () => void;
}
export function IntroStep({
  onStart
}: IntroStepProps) {
  const {
    t
  } = useLanguage();
  const features = [{
    icon: <ScanFace className="w-6 h-6 text-brand-copper" data-id="element-249" />,
    title: t('faceAnalysis.intro.feature1')
  }, {
    icon: <Sparkles className="w-6 h-6 text-brand-copper" data-id="element-250" />,
    title: t('faceAnalysis.intro.feature2')
  }, {
    icon: <ImageIcon className="w-6 h-6 text-brand-copper" data-id="element-251" />,
    title: t('faceAnalysis.intro.feature3')
  }];
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} animate={{
    opacity: 1,
    y: 0
  }} className="max-w-3xl mx-auto bg-white rounded-2xl shadow-xl shadow-brand-copper/5 border border-brand-lightCopper/30 overflow-hidden" data-id="element-252">
      <div className="p-8 md:p-12 text-center" data-id="element-253">
        <div className="w-20 h-20 bg-brand-copper/10 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-254">
          <ScanFace className="w-10 h-10 text-brand-copper" data-id="element-255" />
        </div>

        <h2 className="text-sm font-bold tracking-widest text-brand-copper uppercase mb-3" data-id="element-256">
          {t('faceAnalysis.intro.label')}
        </h2>
        <h3 className="text-3xl md:text-4xl font-light text-gray-900 mb-4" data-id="element-257">
          {t('faceAnalysis.intro.title')}
        </h3>
        <p className="text-gray-600 text-lg mb-10 max-w-xl mx-auto" data-id="element-258">
          {t('faceAnalysis.intro.subtitle')}
        </p>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12" data-id="element-259">
          {features.map((feature, idx) => <div key={idx} className="flex flex-col items-center p-4 bg-gray-50 rounded-xl" data-id="element-260">
              <div className="mb-3" data-id="element-261">{feature.icon}</div>
              <span className="text-sm font-medium text-gray-800 text-center" data-id="element-262">
                {feature.title}
              </span>
            </div>)}
        </div>

        <button onClick={onStart} className="bg-brand-copper text-white px-10 py-4 rounded-full font-medium text-lg hover:bg-brand-darkCopper transition-colors shadow-lg shadow-brand-copper/20 w-full sm:w-auto" data-id="element-263">
          {t('faceAnalysis.intro.start')}
        </button>

        <div className="mt-8 flex items-start justify-center text-xs text-gray-500 max-w-md mx-auto text-left bg-brand-bg/50 p-4 rounded-lg" data-id="element-264">
          <ShieldAlert className="w-4 h-4 mr-2 flex-shrink-0 mt-0.5 text-brand-copper" data-id="element-265" />
          <p data-id="element-266">{t('faceAnalysis.intro.disclaimer')}</p>
        </div>
      </div>
    </motion.div>;
}